@if (sliderScene) {
    <div class="slider-props-panel">
        <!-- Main Content -->
        <div class="panel-content">
            <div class="settings-section">
                <!-- Navigation Buttons -->
                <app-setting-toggle-group
                    icon="touch_app"
                    title="{{ 'ai.navigationalStyle' | transloco }}"
                    name="navigation"
                    ariaLabel="Navigation Mode"
                    [options]="navigationOptions"
                    [hideSingleSelectionIndicator]="false"
                    [ngModel]="navigationMode"
                    (selectionChange)="onChangeNavigationMode($event)">
                </app-setting-toggle-group>

                <!-- Duration -->
                @if (navigationMode === 'time') {
                    <div class="input-group">
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>{{ 'ai.durationSeconds' | transloco }}</mat-label>
                            <input type="number" matInput [formControl]="durationControl" class="hide-spinners">
                            <mat-icon matPrefix>schedule</mat-icon>
                            <span matSuffix>sec</span>
                        </mat-form-field>
                    </div>
                }

                @if (navigationMode === 'slide') {
                    <!-- Navigation Button Size -->
                    <div class="navigation-customization">
                        <div class="setting-item">
                            <div class="setting-header-vertical">
                                <div class="setting-title-row">
                                    <mat-icon class="setting-icon">tune</mat-icon>
                                    <span class="setting-title">{{ 'ai.addActionButtons' | transloco }}</span>
                                </div>
                                <div class="controls-row">
                                    <mat-form-field appearance="outline" class="size-select">
                                        <mat-label>{{ 'ai.size' | transloco }}</mat-label>
                                        <mat-select [(ngModel)]="navigationButtonSize" (selectionChange)="onSizeChange()" [disabled]="!editingSlideSceneId">
                                            @for (option of sizeOptions; track option.value) {
                                                <mat-option [value]="option.value">{{ option.label }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>

                                    <button
                                        mat-icon-button
                                        class="delete-navigation-btn"
                                        [disabled]="!editingSlideSceneId"
                                        (click)="removeAllNavigation()"
                                        [matTooltip]="'ai.removeAllNavigationButtons' | transloco">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Add Touch Buttons Section -->
                    <div class="touch-buttons-section">
                        <div class="setting-item">
                            <div class="setting-header-vertical">
                                <div class="setting-title-row">
                                    <mat-icon class="setting-icon">touch_app</mat-icon>
                                    <span class="setting-title">{{ 'ai.addTouchButtons' | transloco }}</span>
                                </div>

                                <div class="action-buttons-container" [class.disabled]="!editingSlideSceneId">
                                    <div cdkDropList cdkDropListSortingDisabled (cdkDropListDropped)="addOrDragActionButton($event)">
                                        <div cdkDrag (cdkDragStarted)="onDragStart()" (cdkDragEnded)="onDragEnd()">
                                            <button mat-flat-button
                                                    color="primary"
                                                    class="unified-touch-button"
                                                    (click)="addOrDragActionButton()"
                                                    [disabled]="!editingSlideSceneId">
                                                <mat-icon>add_circle_outline</mat-icon>
                                                <span>{{ 'ai.addTouchButton' | transloco }}</span>
                                                <mat-icon>drag_indicator</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <!-- Selected Slide Name - Moved to Bottom -->
                <br/>
                <br/>
                <!-- <div class="input-group">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>{{ editingSlideSceneId ? ('Slide Name' | transloco) : ('No slide selected' | transloco) }}</mat-label>
                        <input autocomplete="off" inputrestriction="basic1" matInput
                               [value]="selectedSlide?.title || ''"
                               [disabled]="!editingSlideSceneId"
                               (keyup)="onChangeSceneName($event)"
                               (change)="onChangeSceneName($event)"
                               [placeholder]="editingSlideSceneId ? 'Enter slide name' : 'Select a slide to rename'">
                        <mat-icon matPrefix>edit</mat-icon>
                    </mat-form-field>
                </div> -->
            </div>
        </div>
    </div>
}
